import qs from "qs";
import { getAuthToken } from "@provider/token";
import { Platform } from "react-native";

const proxyUrl =
  process.env.EXPO_PUBLIC_PROXY_URL || (Platform.OS === "web" ? "http://localhost:8882" : "http://192.168.2.10:8882");
// Canoniek domein sinds de domeinverhuizing (docs/worksheets/2026-10-22-domein-verhuizing.md).
// bio.degroteverleiding.nl blijft de API en /images, /icons, /files serveren voor
// oudere app-versies; nieuwe builds praten met het hoofddomein.
export const siteUrl = process.env.EXPO_PUBLIC_SITE_URL || "https://degroteverleiding.nl";
const prodAssetsUrl = process.env.EXPO_PUBLIC_ASSETS_URL || siteUrl;
const prodApiUrl = process.env.EXPO_PUBLIC_API_URL || `${siteUrl}/api/v2`;
export const assetsUrl = __DEV__ ? proxyUrl : prodAssetsUrl;
export const apiUrl = __DEV__ ? `${proxyUrl}/api/v2` : prodApiUrl;

export const methods = {
  GET: "GET",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
  POST: "POST",
};

export default async function api<T>({
  path,
  params,
  method = methods.GET,
  body,
  token,
}: {
  path: string;
  params?: object;
  method?: string;
  body?: object;
  token?: string;
}): Promise<T> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const authToken = token || getAuthToken();
  if (authToken) {
    headers["Authorization"] = "Bearer " + authToken;
  }

  // console.log({ body });
  const paramsAsString = params ? `?${qs.stringify(params as any, { arrayFormat: "brackets" })}` : "";
  const fullPath = `${apiUrl}${path}${paramsAsString}`;

  if (process.env.NODE_ENV === "development") {
    console.log("[DEV] ", method + " " + fullPath);
  }

  const options: RequestInit = {
    method,
    body: body ? JSON.stringify(body) : null,
    headers,
    // credentials: "include",
    // credentials: "include",
  };

  const response = await fetch(fullPath, options);
  const json = await response
    .json()
    .catch((e) => console.debug("could not parse JSON but it's probably empty JSON so no problem: ", e));

  if (!response?.ok) {
    const error = new Error(getErrorFromJson(json, response.status));
    (error as any).response = response;
    (error as any).json = json;
    throw error;
  }

  return json as T;
}

function getErrorFromJson(json: any, status: any) {
  const fallbackMessage = "Er is iets foutgegaan " + (status ? `(${status})` : "");
  if (json?.errors) {
    const errors = Object.values(json?.errors);
    return errors[0] ? errors[0] : fallbackMessage;
  }
  return json?.error || json?.message || json?.title || fallbackMessage;
}
